// src/components/mafia/minigames/intro/introConfig.js

export const introConfig = {
  safeCracker: {
    title: 'arcade.intro_safecracker_title',
    desc: 'arcade.intro_safecracker_desc',
  },
  quiz: {
    title: 'arcade.intro_quiz_title',
    desc: 'arcade.intro_quiz_desc',
  },
  crimeScene: {
    title: 'arcade.intro_crimescene_title',
    desc: 'arcade.intro_crimescene_desc',
  },
  bombDefusal: {
    title: 'arcade.intro_bomb_title',
    desc: 'arcade.intro_bomb_desc',
  },
  slidingPuzzle: {
    title: 'arcade.intro_sliding_title',
    desc: 'arcade.intro_sliding_desc',
  },
  tetris: {
    title: 'arcade.intro_tetris_title',
    desc: 'arcade.intro_tetris_desc',
  },
  slovodel: {
    title: 'arcade.intro_slovodel_title',
    desc: 'arcade.intro_slovodel_desc',
  },
  wordDuel: {
    title: 'arcade.intro_wordduel_title',
    desc: 'arcade.intro_wordduel_desc',
  },
  minesweeper: {
    title: 'arcade.intro_minesweeper_title',
    desc: 'arcade.intro_minesweeper_desc',
  },
  garage: {
    title: 'arcade.intro_garage_title',
    desc: 'arcade.intro_garage_desc',
  },
  balda: {
    title: 'arcade.intro_balda_title',
    desc: 'arcade.intro_balda_desc',
  },
  wordle: {
    title: 'arcade.intro_wordle_title',
    desc: 'arcade.intro_wordle_desc',
  },
  // Дефолт (фоллбэк)
  default: {
    title: 'arcade.intro_generic_title',
    desc: 'arcade.intro_generic_desc',
  }
};

export const getIntroData = (gameType) => {
  return introConfig[gameType] || introConfig.default;
};